import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AtoConsulta } from 'src/app/shared/model/ato-consulta.model';

@Component({
	selector: 'app-listar-atos-duplicados',
	templateUrl: './listar-atos-duplicados.component.html',
	styleUrls: ['./listar-atos-duplicados.component.css']
})
export class ListarAtosDuplicadosComponent implements OnInit {

	@Input() atosDuplicados: AtoConsulta[];     // Atos com a mesma epígrafe de 'ato' na base
	@Input() conteudoAto: string;				// Conteúdo do ato "novo"
	@Input() idAtoCorrecao: number;				// Em caso de Correção do Ato

	@Output() prosseguir: EventEmitter<number> = new EventEmitter<number>();
	@Output() republicarDaComparacao: EventEmitter<number> = new EventEmitter<number>();
	@Output() converterPublicacaoRepetida: EventEmitter<number> = new EventEmitter<number>();

	// Ordenação
	atosOriginaisDuplicados: AtoConsulta[];
	listaVazia: AtoConsulta[] = [];
	sortedBy: (boolean | undefined)[] = [undefined, undefined, undefined, undefined, undefined, undefined];
	sortedColumn: string[] = ['idAto', 'tipoAto', 'numeroAto', 'orgaos', 'dataAto', 'dataPublicacao'];

	exibirModalCompararAtos = false;
	idAtoBase: number;

	ngOnInit(): void {
		this.atosOriginaisDuplicados = this.atosDuplicados;
	}

	public getEmenta(ementa: string): string {
		const MAX_CARACTERES_EMENTA = 30;
		if (ementa && ementa.length > MAX_CARACTERES_EMENTA) {
			return ementa.substring(0, MAX_CARACTERES_EMENTA) + "...";
		}
		return ementa;
	}

	private resetSortedBy() {
		for (let i = 0; i < this.sortedBy.length; i++) {
			this.sortedBy[i] = undefined;
		}
	}

	public sortByColuna(indice: number, asc: boolean) {
		this.resetSortedBy();
		this.sortedBy[indice] = asc;
		const lista = this.listaVazia.concat(this.atosOriginaisDuplicados);
		if (asc != undefined) {
			lista.sort(AtoConsulta.getFunctionSortBy(this.sortedColumn[indice]));
			if (!asc) {
				lista.reverse();
			}
		}
		this.atosDuplicados = lista;
	}

	public compararAtos(idAtoBase: number) {
		this.idAtoBase = idAtoBase;
		this.exibirModalCompararAtos = true;
	}

	public fecharModalCompararAtos() {
        this.exibirModalCompararAtos = false;
    }

	public fecharModalCompararAtosERepublicar(idAtoOriginalRepublicacao: number) {
        this.fecharModalCompararAtos();
		if (idAtoOriginalRepublicacao && idAtoOriginalRepublicacao > 0) {
			this.republicarDaComparacao.emit(idAtoOriginalRepublicacao);
		}
    }

	public fecharModalCompararAtosEConverterPublicacaoRepetida(idAtoSelecionado: number) {
        this.fecharModalCompararAtos();
		if (idAtoSelecionado && idAtoSelecionado > 0) {
			this.converterPublicacaoRepetida.emit(idAtoSelecionado);
		}
    }

	public fecharModalEProsseguir() {
		this.fecharModalCompararAtos();
		this.prosseguir.emit(0);
	}
}
